import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterContentComponent } from './letter-content.component';
import { TextViewerModule } from '../text-viewer/index';
import { MailmergeAdminViewerModule } from './mailmerge-admin-viewer/mailmerge-admin-viewer.module';
import { MailmergeNonadminViewerModule } from './mailmerge-nonadmin-viewer/mailmerge-nonadmin-viewer.module';

@NgModule({
  declarations: [LetterContentComponent],
  imports: [
    CommonModule,
    TextViewerModule,
    MailmergeAdminViewerModule,
    MailmergeNonadminViewerModule,
  ],
  exports: [LetterContentComponent],
})
export class LetterContentModule { }
